import { Component } from '@angular/core';
import { MixedLoyaltyQuery } from '@fgb/core';
import { FeaturedRewardsModule } from '@fgb/portal-component-library/src/lib/loyalty/featured-rewards';
import { FeaturedRewardsCustomQuery } from './featured-rewards.query';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';

// Wrapper component for the featured events query
@Component({
  selector: 'fgb-featured-rewards-custom',
  standalone: true,
  imports: [FeaturedRewardsModule, FGBSharedModule, DirectivesModule],
  providers: [
    // @HACK: hack to replace data on the featured rewards component with event items
    {
      provide: MixedLoyaltyQuery,
      useClass: FeaturedRewardsCustomQuery
    }
  ],
  templateUrl: './featured-rewards-custom.component.html'
})
export class FeaturedRewardsCustomComponent {

}
